import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/AnalyticsBase.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/App.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/StoreProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/ErrorBoundary/ErrorBoundary.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@vectord/companion/dist/main.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/providers/AntdConfigProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/providers/ThemeProvider.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/styles/global.module.scss");
;
import(/* webpackMode: "eager" */ "/vercel/path0/styles/common.scss");
;
import(/* webpackMode: "eager" */ "/vercel/path0/styles/index.scss");
